export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[100svh] w-full flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20motion%20comic%20illustration%20of%20a%20dramatic%20night%20cityscape%20with%20energetic%20characters%20in%20dynamic%20poses%2C%20warm%20coral%20and%20amber%20glow%20against%20deep%20charcoal%20shadows%2C%20cinematic%20wide%20composition%2C%20rich%20detail%2C%20immersive%20background%20art%2C%20high%20energy%20entertainment%20mood&width=1600&height=900&seq=hero-motion&orientation=landscape"
          alt="韩国动态漫画炫酷开场视觉背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 pb-24 pt-28 text-center md:px-6">
        <span className="mb-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-500/50 bg-background-100/70 px-4 py-1.5 text-xs font-medium text-accent-300 backdrop-blur">
          <i className="ri-flashlight-fill text-accent-400" aria-hidden="true"></i>
          全彩有声 · 特效拉满 · 配音版一集不落
        </span>

        <h1 className="font-heading text-4xl leading-tight text-foreground-50 md:text-6xl">
          韩国动态漫画
          <span className="mt-2 block bg-gradient-to-r from-primary-400 via-accent-400 to-primary-500 bg-clip-text text-transparent">
            在线看 · 点开即播
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-7 text-foreground-200 md:text-base md:leading-8">
          汇聚海量韩国动态漫画，有声全彩、特效拉满，配音版同步更新。视频流畅加载，追更体验不卡壳，一集不落地陪你把好故事追到底。
        </p>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#featured"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400 sm:w-auto"
          >
            <i className="ri-play-circle-fill mr-1.5" aria-hidden="true"></i>立即在线观看
          </a>
          <a
            href="#ranking"
            className="w-full whitespace-nowrap rounded-md border border-foreground-200/30 bg-white/5 px-7 py-3.5 text-sm font-semibold text-foreground-50 backdrop-blur transition-colors hover:border-accent-400 hover:text-accent-300 sm:w-auto"
          >
            浏览热门榜单
          </a>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-3 gap-4 md:gap-6">
          {[
            { num: '800+', label: '在库作品' },
            { num: '12+', label: '每日更新' },
            { num: '8+', label: '配音语种' },
          ].map((item) => (
            <div key={item.label} className="rounded-lg border border-background-300/40 bg-background-100/50 px-2 py-4 backdrop-blur">
              <dd className="font-heading text-2xl text-accent-400 md:text-3xl">{item.num}</dd>
              <dt className="mt-1 text-xs text-foreground-300 md:text-sm">{item.label}</dt>
            </div>
          ))}
        </dl>
      </div>

      <a
        href="#features"
        className="absolute bottom-6 left-1/2 z-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border border-foreground-200/30 text-foreground-200 transition-colors hover:border-primary-400 hover:text-primary-400"
        aria-label="向下滚动查看更多内容"
      >
        <i className="ri-arrow-down-line" aria-hidden="true"></i>
      </a>
    </section>
  );
}